import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import Text from "../../../molecules/content/Text";
import FloatingInputField from "../../../molecules/formControls/inputField/FloatingInputField";
import PasswordRuleList from "../../../molecules/formControls/validation/PasswordRuleList";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import ChangePasswordValidation from "./validation";

const ChangePasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation();

  const initialValues = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ChangePasswordValidation(t),
    onSubmit,
  });

  return (
    <form
      className="flex flex-col gap-8"
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <FloatingInputField
        id="oldPassword"
        name="oldPassword"
        title={t("changePassword.oldPassword")}
        label={t("changePassword.oldPassword")}
        required
        type="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.oldPassword}
        formikTouched={formik.touched.oldPassword}
        error={formik.errors.oldPassword}
      />
      <FloatingInputField
        id="newPassword"
        name="newPassword"
        label={t("changePassword.newPassword")}
        required
        type="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.newPassword}
        formikTouched={formik.touched.newPassword}
        error={formik.errors.newPassword}
      />
      <PasswordRuleList password={formik.values.newPassword} />
      <FloatingInputField
        id="newPasswordConfirm"
        name="newPasswordConfirm"
        label={t("changePassword.newPasswordConfirm")}
        required
        showDefaultValidation
        type="password"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.newPasswordConfirm}
        formikTouched={formik.touched.newPasswordConfirm}
        error={formik.errors.newPasswordConfirm}
      />
      <Text variant="small" className="text-center">
        {t("changePassword.description")}
      </Text>
      <DefaultButton
        type="submit"
        label={t("forgotPassword.submit")}
        disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default ChangePasswordForm;
